var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('onboarding',{on:{"click:open-info":function($event){_vm.isFnrhInfoModalOpen = true},"click:letsgo":function($event){return _vm.$store.dispatch('flow/reservation/next')}}}),_c('fnrh-info-modal',{attrs:{"opened":_vm.isFnrhInfoModalOpen},on:{"click:close":function($event){_vm.isFnrhInfoModalOpen = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }